import React from 'react';
import { Button } from '@salesforce/design-system-react';
import { ReScanButton } from '../buttons/ReScanButton';
import styles from './Header.module.scss';

type HeaderProps = {
  onBook: () => void;
};
export const Header: React.FC<HeaderProps> = ({onBook}) => {
  return (
    <div className={styles.DashboardHeader}>
      <div className={styles.DashboardMessage}>
        <p>Each component of your org security scan has been given a letter grade and contains actionable data points to fix org vulnerabilities.</p>
        <p>Ready to take the next step? Book a meeting to learn how the Flosum Trust Center remediates these issues.</p>
        <Button className={styles.ButtonBook} label='Book a Meeting' variant='brand' onClick={onBook} />
      </div>
      Your <span className={styles.DashboardHeader_Primary}>Dashboard</span>
      <ReScanButton className={styles.ButtonHeader} />
    </div>
  );
}
